// extracted by mini-css-extract-plugin
export default {"pageRoot":"StructuralEngineersPage_pageRoot__IfIFo","pageContent":"StructuralEngineersPage_pageContent__adDeZ"};